module.exports = "\n    <app-left-menu-order style=\"width: 95%\"></app-left-menu-order>"